import Cookies from "universal-cookie";
import {USER_TYPE} from "./api-service";

export class tokenService {
  cookies;

  constructor() {
    this.cookies = new Cookies();
  }

  async set(user: USER_TYPE, data: any) {
    await this.cookies.set(user + "-cookie", JSON.stringify(data), {sameSite: true, path: "/"});
  }

  async get(user: USER_TYPE) {
    const data = await this.cookies.get(user + "-cookie");
    return data || null;
  }

  async remove(user: USER_TYPE) {
    const data = await this.cookies.remove(user + "-cookie", {sameSite: true, path: "/"});
  }
}
